// extracted by mini-css-extract-plugin
export default {"switch":"Toggle_switch__lYDLG","slider":"Toggle_slider__VDhKk","disabled":"Toggle_disabled__tPDLE","color":"Toggle_color__9XAtR"};